import { Action, Reducer } from 'redux';

export type ObjectValues<O extends { [key: string]: any }> = O[keyof O];

export type Dictionary<V> = { [key: string]: V };

type ActionCreator<T extends string> = (...args: any[]) => Action<T>;

export type ActionType<AC> = AC extends ActionCreator<string>
  ? ReturnType<AC>
  : AC extends Dictionary<any>
  ? { [K in keyof AC]: ActionType<AC[K]> }[keyof AC]
  : never;

export type StateType<R extends Reducer> = ReturnType<R>;

export const createAction = <T extends string, A extends Action<T>>(action: A): A => action;

/**
 * Equivalent to `assertExhaustive` for reducers. The `assertExhaustive` helper throws on
 * every call, which does not work for reducers because actions that do not match one of
 * the switch cases always fall through to the default case, which is expected to return
 * unmodified state.
 */
export const endReducer = <T>(state: T, action: never): T => state;
